// Vue
import {Vue, Component, Prop, Inject} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {NextStepNavigation} from "../next_step_navigation/NextStepNavigation";
import {NextStepNavigationItem} from "../../../interfaces/NextStepNavigationItem";
import {HttpService} from "../../../services/HttpService";

@Component({
    mixins: [template],
    components: {
        NextStepNavigation
    }
})
export class NextStepNavigationDefault extends Vue {

    private readonly http: HttpService = HttpService.instance

    @Prop()
    private portalId!: number

    @Prop()
    public language!: string;

    @Prop()
    public country!: string;

    @Prop({default: null})
    private pageId!: number|null

    // For CMS only
    @Prop({default: false})
    private editMode!: boolean

    private items: object[] = []

    public getBackgroundColorFromInstance(instance: object) {
        return 'black';
    }

    private isActive(item: NextStepNavigationItem) {
        return this.pageId && this.pageId == item.id;
    }

    public async mounted() {
        this.items = (await this.loadItems())
            .map((item: NextStepNavigationItem) => {
                return {
                    id: item.id,
                    href: item.link,
                    target: item.link_target,
                    icon: item.design.svg_icon,
                    text: item.basic.title,
                    active: this.isActive(item)
                }
            })
    }

    private async loadItems() {
        let url = `${APP_API_URL}cms/${this.language}/${this.country}/${this.portalId}/next-step-navigation`;
        let response = await this.http.get<NextStepNavigationItem[]>(url);

        return response.body!
    }
}
